<template>
    <MainContent :title="'Detalle del ' + role">
        <template v-slot:header v-if="taquillero">
            <h3 class="card-title my-3">Datos del {{ role }}: {{ taquillero.name }}</h3>
            <div class="my-3">
                <router-link class="btn btn-primary mr-3" :to="{ name: 'back.taquilleros.index' }">
                    Volver al listado
                </router-link>

                <OpcionesDropdownComponent v-bind:options="[
                    { to: { name: 'back.taquilleros.editar', params: { taquillero_id: taquillero.id, role: role }}, label: 'Editar taquillero'},
                ]"
                />
            </div>
        </template>
        <template v-slot:content v-if="taquillero">

            <b-table hover :items="taquillero.permisos" :fields="fields">
                <template #cell(value)="data">
                    <CheckOrCross :condition="data.value"/>
                </template>
            </b-table>

        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import OpcionesDropdownComponent from '@/components/backend/components/OpcionesDropdownComponent';
    import CheckOrCross from "@/components/backend/components/CheckOrCross";

    export default {
        props: ['taquillero_id', 'role'],
        data() {
            return {
                taquillero: null,
                fields: [
                    {
                        key: 'label',
                        label: 'PERMISO'
                    },
                    {
                        key: 'value',
                        label: 'ACTIVADO',
                        class: 'text-center'
                    }
                ]
            }
        },
        created() {
            this.getTaquillero();
        },
        methods: {
            getTaquillero: function() {
                const params = {
                    taquillero_id: this.taquillero_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.taquilleros.show'), params).then(res => {
                    this.taquillero = res.data.taquillero;
                });
            }
        },
        components: {
            CheckOrCross,
            MainContent,
            OpcionesDropdownComponent
        }
    }
</script>
